import Http from "./http";

export const getGroupProductFeatureAPI = (data) => {
    return Http.post("admin/group/getGroupProductFeature", data);
};
